import * as React from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardList = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(List, {
    children: /*#__PURE__*/_jsx(Flex, {
      columnGap: isMobile ? undefined : '400',
      flexDirection: isMobile ? 'column' : 'row',
      flexWrap: isMobile ? undefined : 'wrap',
      inlineSize: isMobile ? '100%' : 'fit-content',
      marginInline: isMobile ? undefined : 'auto',
      rowGap: '600',
      children: React.Children.map(children, (child, index) => {
        var _key;
        return /*#__PURE__*/_jsx(Box, {
          basis: isMobile ? '100%' : '400px',
          shrink: 0,
          children: child
        }, (_key = child === null || child === void 0 ? void 0 : child.key) !== null && _key !== void 0 ? _key : index);
      })
    })
  });
};